import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { name } from './symbols'
import { CarmiInstance, EditorFeatureConfigSymbol, ViewerModel, ViewerModelSym } from '@wix/thunderbolt-symbols'
import { ViewerManagerSvgApiEditorConfig } from './types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { ParsedSvg, vectorImage } from '@wix/thunderbolt-commons'

const viewerManagerSvgApiFactory = (
	{ fetchRequestsStore, isResponsive }: ViewerManagerSvgApiEditorConfig,
	{ svgStore }: DSCarmi,
	{ media: { mediaRootUrl } }: ViewerModel
): IViewerManagerImplementor<'svg'> => {
	const { buildSvgUrl } = vectorImage.buildSvgUrlFactory()

	return {
		svg: {
			addSvgShape: (svgId: string, svgShape: object): void => {
				svgStore.setSvg(buildSvgUrl(mediaRootUrl, svgId), ((svgShape as unknown) as ParsedSvg).content)
			},
			getSvgShape: (svgId: string): object => {
				const svgString = fetchRequestsStore[buildSvgUrl(mediaRootUrl, svgId)]
				const parsedSvg = svgString ? vectorImage.parseSvgString(svgString) : (undefined as any)
				return isResponsive && parsedSvg ? { ...parsedSvg, boxBoundaries: {} } : parsedSvg
			},
		},
	}
}

export const ViewerManagerSvgApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), CarmiInstance, ViewerModelSym],
	viewerManagerSvgApiFactory
)
